<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-02-21 17:15:50
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-02-21 17:17:11
 * @FilePath: \xm-runing-main\src\components\selectUserCtl\components\user-show-item.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
/**
* @name: user-show-item
* @author: weiyong
* @date: 2023-02-21 15:26
* @description：user-show-item
* @update: 2023-02-21 15:26
*/
<template>
  <div class="user-show-item flex-div-bet" @click="selItemRecord">
    <div class="left-area flex-div" style="flex: 1">
      <user-img-avatar :icon="icon" :label="label" :item="item"/>
      <div class="module__right">
        <div class="user-label">{{ label }}</div>
        <div class="user-label role-info" v-if="remark&&remark!=='[]'">{{ remark||'' }}</div>
      </div>
    </div>
    <div v-if="hasCheck" style="padding-right: 20px">
      <a-checkbox v-model:checked="item.check"/>
    </div>
    <div v-if="hasDel" style="padding-right: 20px">
        <span @click="delRecord">
          <i style="color:#777;" class="remix-icon ri-delete-bin-line"></i>
        </span>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "user-show-item",
});
</script>

<script lang="ts" setup>
import UserImgAvatar from '../../userImgAvatar/index.vue';
import {Checkbox as ACheckbox} from 'ant-design-vue'

const props = defineProps({
  multiple:{},
  item: {},
  hasDel: {},
  hasCheck: {},
  remark: {},
  icon: {},
  label: {}
});
const {icon, label, item, hasCheck}: any = toRefs(props);



const emits = defineEmits(['selItemRecord','delRecord']);
/**
 * 选择记录
 */
const selItemRecord = function () {
  if(props.multiple===false){
    unref(item).check =true;
    emits('selItemRecord', {item});
  }else{
    if (unref(hasCheck)) {
      unref(item).check = !unref(item).check;
      emits('selItemRecord', {item})
    }
  }
}

const delRecord=function (){
  emits('delRecord', {item})
}
</script>

<style type="text/css" lang="less">
.user-item-record {
  .user-show-item {
    padding: 14px 10px 10px 10px;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }
  }
}

.user-show-item {
  display: flex;
  padding-top: 2px;

  .wemail-avatar-wrap {
    margin-right: 8px;
  }

  .use-img {
    width: 35px;
    height: 35px;
    border-radius: 6px;
    background-color: var(--ant-primary-color,#0a6eff);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
  }

  .module__right {
    position: relative;
    top: -5px;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .user-label {
    width: 100%;
    padding-left: 4px;
  }

  .role-info {
    font-size: 12px;
    color: #888;
    position: relative;
    top: 1px;
    font-weight: normal;
  }
}

</style>
